<template>
  <div class="download">
    <i class="back" @click="back"></i>
    <img :src="boxImg" />
    <h2>下载家长盒子APP</h2>
    <h3>并关联学生账号即可开启盒子</h3>
    <div class="wordbox">
      <div v-if="classUser" class="classMes">
        <p>{{classUser}}</p>
        <p>用家长盒子辅导孩子学习</p>
      </div>
      <div class="item">
        <i></i>
        <span>了解孩子的学习表现和薄弱点</span>
      </div>
      <div class="item">
        <i></i>
        <span>布置针对性的错题巩固练习&nbsp;&nbsp;&nbsp;</span>
      </div>
    </div>
    <p class="btn" @click="download">下载家长盒子</p>
    <h4>需安装最新版本</h4>
  </div>
</template>

<script>
import utils from "@/assets/js/utils";
import ajax from "@/api/studentAjax";
import box_red from "@/assets/images/parent_active/prize/red_box.png";
import box_yellow from "@/assets/images/parent_active/prize/yellow_box.png";
import box_blue from "@/assets/images/parent_active/prize/blue_box.png";
const boxImg = {
  1: box_red,
  2: box_yellow,
  3: box_blue
};
export default {
  name: "download",
  data() {
    return {
      classUser: "",
      boxImg: ""
    };
  },
  methods: {
    back: function() {
      let url = "hybird://method/exit";
      location.href = url;
    },
    download: function() {
      let token = utils.getQueryString("token");
      utils.sendLog(
        {
          token: token,
          source: "h5"
        },
        "jz0225"
      );
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        location.href =
          "itms-apps://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1142530651";
      } else if (navigator.userAgent.match(/android/i)) {
        // location.href = 'https://appd.knowbox.cn/parent/AndroidRCParent_par_libao.apk';
        let url =
          "hybird://method/openParentClient?minVersion=320&url=https://appd.knowbox.cn/parent/AndroidRCParent_par_libaov2.apk";
        location.href = url;
      }
    }
  },
  created: async function() {
    let classId = utils.getQueryString("classId");
    let token = utils.getQueryString("token");
    let boxId = utils.getQueryString("boxId");
    this.boxImg = boxImg[boxId];
    const [resp] = await ajax.all([
      ajax.get("/student/act/get-parent-info-in-class", {
        params: {
          token: token,
          classId: classId
        }
      })
    ]);
    if (resp.data.code == 99999) {
      this.classUser = resp.data.data.parentInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
.download {
  background: url("../../assets/images/parent_active/prizeBg.png") 0 0 / cover
    no-repeat;
  min-height: 100vh;
  text-align: center;
  img {
    margin: 0.69rem auto 0.52rem;
    width: 2.08rem;
    height: 2.08rem;
  }
  h2 {
    line-height: 0.38rem;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #ffdc60;
  }
  h3 {
    line-height: 0.29rem;
    margin-top: 0.26rem;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    color: #ffffff;
  }
  h4 {
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #d5caef;
  }
  .back {
    position: absolute;
    top: 0.26rem;
    left: 0.38rem;
    width: 0.2rem;
    height: 0.34rem;
    background: url("../../assets/images/parent_active/prize/download_back.png")
      0 0 / cover no-repeat;
  }
  /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.31rem+ constant(safe-area-inset-top));
      top: calc(0.31rem+ env(safe-area-inset-top));
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .back {
      top: 0.8rem;
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: 0.8rem;
    }
  }
  .wordbox {
    margin: 1.63rem auto 1.14rem;
    width: 5.8rem;
    padding: 0.63rem 0 0.8rem;
    background-color: #362f8f;
    border-radius: 0.3rem;
    font-family: PingFangSC-Medium;
    font-size: 0.28rem;
    line-height: 0.42rem;
    color: #ffffff;
    .item {
      margin-top: 0.25rem;
      height: 0.27rem;
      line-height: 0.27rem;
      i {
        display: inline-block;
        margin-right: 0.2rem;
        width: 0.2rem;
        height: 0.17rem;
        background: url("../../assets/images/parent_active/prizeIcon.png") 0 0 /
          cover no-repeat;
      }
    }
    .classMes {
      margin-bottom: 0.82rem;
      p {
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        line-height: 0.44rem;
        color: #d5caef;
      }
    }
  }
  .btn {
    margin: 0 auto 0.18rem;
    width: 5.8rem;
    height: 1rem;
    line-height: 1rem;
    background-color: #ff4c4f;
    border-radius: 0.5rem;
    font-family: PingFangSC-Semibold;
    font-size: 0.34rem;
    color: #ffffff;
  }
}

/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .download {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .download {
    padding-top: 1rem;
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .download {
    padding-top: 1rem;
  }
}
</style>